export default "__VITE_ASSET__eLaQRgMR__"